import {getToken} from "firebase/messaging"
import {messaging} from "../../config/firebaseConfig"
import {updateUserPushNotificationToken} from "../api/graphql/pushNotification"
import {checkBrowserFirebaseCompatibility} from "./function"

const PUSH_PLATFORM = "web"

export const isPushSupported = () => checkBrowserFirebaseCompatibility() && !!messaging

export const getPushPermission = () => (checkBrowserFirebaseCompatibility() ? Notification.permission : "unsupported")

export async function registerPushToken(vapidKey) {
    if (!isPushSupported()) return null

    const token = await getToken(messaging, {vapidKey})
    if (!token) return null

    localStorage.setItem("fcmToken", token)

    const userId = localStorage.getItem("userid")
    if (userId) {
        await updateUserPushNotificationToken({
            user: userId,
            token: token,
            provider: "firebase",
            platform: PUSH_PLATFORM,
        })
    }

    return token
}

// Safari rejects requestPermission outside a user gesture, so this must stay on a click path.
export async function requestPushPermission(vapidKey) {
    if (!isPushSupported()) return "unsupported"

    const permission = await Notification.requestPermission()
    if (permission === "granted") {
        await registerPushToken(vapidKey)
    }

    return permission
}
